import { GetOrgAccountSummaryReturn as PaymentAccountSummary } from "api";
import { OrgState } from "../state";

export function updateAccountSummaryStart(state: OrgState) {
    return { ...state, loadingAccountSummary: true };
}

export function updateAccountSummary(
    state: OrgState,
    action: { payload: { organizationId: string; error?: Error; accountSummary?: PaymentAccountSummary } }
) {
    const { error, organizationId, accountSummary } = action.payload;
    const newState: Partial<OrgState> = { error };

    if (organizationId && accountSummary) {
        newState.currentPaymentSummary = accountSummary;
    } else {
        newState.currentPaymentSummary = undefined;
    }

    return { ...state, ...newState, loadingAccountSummary: false };
}
